import { RootStateOrAny, useSelector } from 'react-redux';

import {
  getAccountMembershipProductInfo,
  getMembershipCartItemInfo,
} from '../../utils/selectors';
import { useFreeShipping } from '../../utils/useFreeShipping';

export function useMemberFreeShipping() {
  const accountMembershipItemInfo = useSelector(
    getAccountMembershipProductInfo
  );
  const membershipItemInfo = useSelector(getMembershipCartItemInfo);
  const activeMembershipInfo = accountMembershipItemInfo || membershipItemInfo;

  return activeMembershipInfo ? activeMembershipInfo.freeShipping : false;
}

export function useIsFreeShippingFlagEnabled() {
  const isOpen = useSelector(
    (state: RootStateOrAny) => state.cart.cartDrawerIsOpen
  );
  return useFreeShipping(isOpen);
}
